import { z } from 'zod';

export const CodeEnforcementVehicleScalarFieldEnumSchema = z.enum(['vehicleId','cityId','caseId','vehicleStatus','vehicleMake','vehicleModel','vehicleYear','vehicleColor','vehicleLicense','vehicleState','vehicleExpire','vehicleVIN','note','dateVehicleClosed','rowTimestamp']);

export default CodeEnforcementVehicleScalarFieldEnumSchema;
